import Vue from "vue";
import ElementUI from "element-ui";

//import "element-ui/lib/theme-chalk/index.css";
//自定义样式
import "@/assets/style/element-variables.scss";
// global css
import "@/assets/style/admin.scss";
import "@/assets/style/index.scss";

import App from "./App.vue";
import router from "./router";
import store from "./store";

import http from "./http";

Vue.use(ElementUI);

// Vue.prototype.$uploadURL = 'https://dhpapi.pro.xzusoft.com/api/upload';
// 线上环境
 Vue.prototype.$uploadURL = "https://yxpt.xzusoft.com/api/upload";
//Vue.prototype.$uploadURL = "https://dhpapi.pro.xzusoft.com/api/upload";
// 测试环境
// Vue.prototype.$uploadURL = "https://yxpt.test.xzusoft.cn/api/upload";
// 注册全局资源
// import register from '@/register'
// Vue.use(register);

// 注册 v-has 指令（权限控制）
Vue.directive("has", {
  inserted: function(el, binding) {
    if (Vue.prototype.$_has && !Vue.prototype.$_has(binding.value)) {
      el.parentNode.removeChild(el);
    }
  },
});

//自动化表单
import EleForm from "vue-ele-form";
import EleFormTreeSelect from "vue-ele-form-tree-select";
import EleFormDynamic from "vue-ele-form-dynamic";
// 注册 tree-select 组件
Vue.component("tree-select", EleFormTreeSelect);
Vue.use(EleForm);
import EleFormUploadFile from "vue-ele-form-upload-file";
import EleFormImageUploader from "vue-ele-form-image-uploader";
// 注册 upload-file 组件
Vue.component("upload-file", EleFormUploadFile);
Vue.component("image-uploader", EleFormImageUploader);
Vue.component("dynamic", EleFormDynamic);
Vue.use(EleForm, {
  dynamic: {
    delimiter: "/",
  },
});
//行内编辑
import EleEditable from "vue-ele-editable";
Vue.use(EleEditable);
//编辑器
import VueQuillEditor from "vue-quill-editor";
Vue.use(VueQuillEditor);

import FRender from "f-render";
import "element-ui/lib/theme-chalk/index.css";
Vue.component("f-render", FRender);
// import 'quill/dist/quill.core.css';
// import 'quill/dist/quill.snow.css';
// import 'quill/dist/quill.bubble.css';
// 注册地图组件
import EleFormBmap from "vue-ele-form-bmap";
// 注册 vue-ele-form
Vue.use(EleForm, {
  // 可以为编辑器配置全局属性, 每个实例都共享这个属性
  bmap: {
    // 比如设置 ak 后, 所有的 bmap 编辑器上传图片都会采用这个属性值
    ak: "YOUR_APP_KEY",
  },
});
// 注册 bmap 组件
Vue.component("bmap", EleFormBmap);
// 注册高德地图
import VueAMap from "vue-amap";
Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
  key: "4f273cfb51c1e20568b7f129aafd2e01",
  plugin: [
    "Geocoder",
    "AMap.Autocomplete",
    "AMap.PlaceSearch",
    "AMap.Scale",
    "AMap.OverView",
    "AMap.ToolBar",
    "AMap.MapType",
    "AMap.PolyEditor",
    "AMap.CircleEditor",
  ],
  // 默认高德 sdk 版本为 1.4.4
  v: "1.4.4",
  uiVersion: "1.0.11",
});
// https://zs.xzu.ink/api/upload
import EleFormQuillEditor from "vue-ele-form-quill-editor";
// 注册 vue-ele-form
Vue.use(EleForm, {
  // 可以为编辑器配置全局属性, 每个实例都共享这个属性
  "quill-editor": {
    // 比如设置上传 action 后, 所有的 quill-editor 编辑器上传图片都会采用这个属性'https://wy.alizhiyou.cn/api/upload'
     action: "https://yxpt.xzusoft.com/api/upload",
   // action: "https://dhpapi.pro.xzusoft.com/api/upload",
  },
});

// 全局挂载时间格式化方法
Date.prototype.Format = function(fmt) {
  //author: meizz
  var o = {
    "M+": this.getMonth() + 1, //月份
    "d+": this.getDate(), //日
    "h+": this.getHours(), //小时
    "m+": this.getMinutes(), //分
    "s+": this.getSeconds(), //秒
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
    S: this.getMilliseconds(), //毫秒
  };
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(
      RegExp.$1,
      (this.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
  return fmt;
};

// 注册 quill-editor 组件
Vue.component("quill-editor", EleFormQuillEditor);

// 注册自定义表单组件
import CustomUrl from "@/project-management/assets/components/custom-url.vue";
Vue.component(CustomUrl.name, CustomUrl);
// 图标筛选表单组件
import selectIcon from "@/project-management/assets/components/select-icon.vue";
Vue.component(selectIcon.name, selectIcon);
// 表单高德地图组件
import gmap from "@/project-management/assets/components/gmap.vue";
Vue.component(gmap.name, gmap);

Vue.prototype.http = http;

Vue.config.productionTip = false;

import "@/utils/errorLog";

new Vue({
  data() {
    return {
      AccessControl: false,
    };
  },

  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
